import React, { Component } from "react";
import { Link } from "react-router-dom";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import { Button, Card, Col, Row, Space } from "antd";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import HelpModal from "./HelpModal";
import { Tooltip } from "antd";
import Cookies from "universal-cookie";
import conf from "../config";
import { Border } from "react-bootstrap-icons";
import {
  QuestionCircleOutlined,
  BellOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";

import advanceDashboardIcon from "../assets/images/launchingdashboard/advance-dashboard.svg";
import maintenanceIcon from "../assets/images/launchingdashboard/mentainance-dashboard.svg";
import alertsIcon from "../assets/images/launchingdashboard/alerts.svg";
import dashboardIcon from "../assets/images/launchingdashboard/dashboard.svg";
import detailTrackingIcon from "../assets/images/launchingdashboard/detail-tracking.svg";
import expirySoonIcon from "../assets/images/launchingdashboard/expiring-soon.svg";
import helpIcon from "../assets/images/launchingdashboard/help.svg";
import liveTrackingIcon from "../assets/images/launchingdashboard/live-tracking.svg";
import historyTrackingIcon from "../assets/images/launchingdashboard/history-tracking.svg";
import mastersIcon from "../assets/images/launchingdashboard/masters.svg";
import reportsIcon from "../assets/images/launchingdashboard/reports.svg";
import videoMonitoringIcon from "../assets/images/launchingdashboard/video-monitoring.svg";
import bgVideo from "../assets/images/launchingdashboard/3597717219-preview.mp4";
import logoNew from "../assets/images/logoNew.jpg";
import logoutIcon from "../assets/images/launchingdashboard/logout.svg";

import "../assets/css/launchingdashboard.css";

class LounchingDashboard extends Component {
  constructor(props, context) {
    super(props);
    this.cookies = new Cookies();
    this.rolePermission2 = JSON.parse(localStorage.getItem("rolePermission2"));

    let masterChildren = [];
    let reportChildren = [];
    Object.entries(this.rolePermission2).forEach(([key, value]) => {
      if (value.parentId == 1) {
        masterChildren.push(value.moduleId);
      }
      if (value.parentId == 56) {
        reportChildren.push(value.moduleId);
      }
    });

    let masterUrl = "";
    let reportUrl = "";
    Object.entries(this.rolePermission2).forEach(([key, value]) => {
      if (
        Number(this.props.getUserData().isadmin) === 0 &&
        value.path === "companyList"
      )
        return;
      if (
        masterChildren.includes(value.parentId) &&
        masterUrl.length < 1 &&
        value.canView === 1
      ) {
        masterUrl = value.path;
      }
      if (
        reportChildren.includes(value.parentId) &&
        reportUrl.length < 1 &&
        value.canView === 1
      ) {
        reportUrl = value.path;
      }
    });

    let cookies2 = this.cookies.get("data");
    if (JSON.parse(base64_decode(cookies2))?.logo) {
      this.setState({ logo: JSON.parse(base64_decode(cookies2))?.logo });
    }
    // this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")

    this.features = [
      {
        title: context.translate("_ADVANCE_DASHBOARD_"), //"Advanced Dashboard",
        class: "advancedashboardClass",
        spanClass: "flexclass",
        description: context.translate("_ADVANCE_DASHBOARD_DESC_"),
        // "Customize widgets and use advanced filters on detailed charts for in-depth KPI analysis and tailored reports.",
        span: 8,
        url: "AdvanceDashboard",
        icon: advanceDashboardIcon,
      },
      {
        title: context.translate("_DASHBOARD_"), //"Dashboard",
        class: "dashboardClass",
        spanClass: "flexclass",
        description: context.translate("_DASHBOARD_DESC_"),
        //  "Get a quick overview of key metrics with customizable widgets and charts. Easily monitor progress and spot trends.",
        span: 8,
        url: "dashboard",
        icon: dashboardIcon,
      },
      {
        title: context.translate("_MASTERS_"), // "Masters",
        class: "mastersClass",
        spanClass: "flexclass",
        description: context.translate("_MASTERS_DESC_"), //"Configure core system settings.",
        span: 4,
        url: masterUrl,
        icon: mastersIcon,
      },
      {
        title: context.translate("_FLEET_REPORTS_TAB_"), //"Reports",
        class: "reportsClass",
        spanClass: "flexclass",
        description: context.translate("_FLEET_REPORTS_DESC_"), //"Generate detailed summaries & analyses of tracked data.",
        span: 4,
        url: reportUrl,
        icon: reportsIcon,
      },
      {
        title: context.translate("_HISTORY_TRACKING_"), //"History Tracking",
        class: "historytrackingClass",
        spanClass: "alignClass",
        description: context.translate("_HISTORY_TRACKING_DESC_"),
        // "Explore past data and trends in a detailed log of activities and changes. Analyze performance and identify patterns for insights.",
        span: 4,
        url: "historytracking",
        icon: historyTrackingIcon,
      },
      {
        title: context.translate("_DETAILED_TRACKING_"), //"Detail Tracking",
        class: "detailTrackingClass",
        spanClass: "alignClass",
        description: context.translate("_DETAIL_TRACKING_DESC_"),
        // "Examine specific events and attributes with comprehensive information on individual tracked items.",
        span: 4,
        url: "detailtracking",
        icon: detailTrackingIcon,
      },
      {
        title: context.translate("_LIVE_TRACING_"), //"Live Tracking",
        class: "livetrackingClass",
        spanClass: "alignClass",
        description: context.translate("_LIVE_TRACING_DESC_"),
        // "See real-time locations and statuses for instant updates on ongoing activities. Monitor progress and react swiftly.",
        span: 8,
        url: "livetracking",
        icon: liveTrackingIcon,
        style: { backgroundColor: "#009CFF", color: "#fff" },
      },
      {
        title: context.translate("_MAINTENANCE_DASHBOARD_"), //"Maintenance Dashboard",
        class: "maintenanceClass",
        spanClass: "flexclass",
        description: context.translate("_MAINTENANCE_DASHBOARD_DESC_"),
        // "Monitor system health, performance metrics, and operational status for proactive maintenance.",
        span: 8,
        url: "maintenancedashboard",
        icon: maintenanceIcon,
      },
      {
        title: context.translate("_EXPIRINGSOON_"), //"Expiring Soon",
        class: "expirySoonClass",
        spanClass: "flexclass",
        description:
          "View & manage items nearing expiration. Proactively address deadlines and prevent disruptions.",
        span: 8,
        url: "vehiclelist/4",
        icon: expirySoonIcon,
      },
      {
        title: context.translate("_VIDEO_MONITORING_"), //"Video Monitoring",
        class: "videoMonitorClass",
        spanClass: "flexclass",
        description: context.translate("_VIDEO_MONITORING_DESC_"),
        // "View live and recorded video feeds from integrated cameras to monitor activities and enhance security.",
        span: 8,
        url: "videomonitoring",
        icon: videoMonitoringIcon,
      },
      {
        title: context.translate("_ALERTS_"), //"Alerts",
        class: "alertsClass",
        spanClass: "alignClass",
        description: context.translate("_ALERTS_DESC_"),
        // "Manage real-time notifications and triggers for critical updates based on events or thresholds. Stay instantly informed.",
        span: 4,
        url: "alertlist",
        icon: alertsIcon,
      },
      {
        title: context.translate("_HELP_"), //"Help",
        class: "helpClass",
        spanClass: "alignClass",
        description: context.translate("_HELP_DESC_"),
        // "Access documentation, tutorials, and support to learn how to use the software and find answers.",
        span: 4,
        url: "help",
        icon: helpIcon,
        extraInfo: (
          
          

          <div
            style={{
              marginBottom: "5px",
              cursor: "pointer",
            }}
            
          >
           {conf.project!=='proawtltrack' && <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => this.sendEmail()}
            >
              <i
                class="bi bi-envelope"
                style={{
                  fontSize: "18px",
                  color: "red",
                  marginRight: "5px",
                }}
              ></i>
              {conf.project === "starlingeye"
                ? "support@starlingtechs.com"
                : "vijeta@pointmatrix.ae"}
            </div>}

           { conf.project=='proawtltrack' && <div
              style={{
                display: "flex",
                alignItems: "center",
                marginInlineStart: "40px",
              }}
              
            >
              <i
                class="bi bi-whatsapp"
                style={{
                  fontSize: "18px",
                  color: "green",
                  marginRight: "5px",
                }}
              ></i>
              +966115003419
            </div>}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginInlineStart: "40px",
                // justifyContent: "center",
              }}
            >
              <i
                class="bi bi-telephone"
                style={{
                  fontSize: "18px",
                  color: "teal",
                  marginRight: "5px",
                }}
              ></i>
              {conf.project === "starlingeye"
                ? "+97142734585"
                :conf.project==='proawtltrack'?'+966115003419':'+971503606930'}
            </div>
          </div>
        ),
      },
    ];
  }

  sendEmail = () => {
    window.open("https://www.google.com/intl/en/gmail/about/");
  };

  updateDashboard = (url, value) => {
    const encodedCookieData = this.cookies.get("data");
    const decodedCookieData = JSON.parse(base64_decode(encodedCookieData));
    decodedCookieData.showLaunchingDashboard = value;

    const updatedEncodedCookieData = base64_encode(
      JSON.stringify(decodedCookieData)
    );
    this.cookies.set("data", updatedEncodedCookieData, { path: "/" });
    if (url !== "help") {
      this.props.navigate(url);
    }
    this.setState({ update: 1 });
  };

  componentDidMount() {
    // this.updateDashboard(1);
  }

  handleLogout = () => {
    this.cookies.remove("isAdmin");
    this.props.removeCookie("data", { path: "/" });
    localStorage.removeItem("rolePermission");
    localStorage.removeItem("rolePermission2");
    this.props.navigate("/login");
  };

  splitString = (text) => {
    return (
      <div>
        {text.split(" ").map((word, index) => (
          <div key={index}>{word}</div>
        ))}
      </div>
    );
  };

  render() {
    return (
      <div
        className="lounchingDashboard"
        style={{ height: "100vh", overflowY: "hidden" }}
      >
        <video autoPlay muted loop playsInline className="background-video">
          <source src={bgVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="topBar">
          <img
            src={
              this.state?.logo
                ? conf.fleetURL + "/images/companylogo/" + this.state.logo
                : require("../assets/images/" + conf.launchingDashboardLogo)
            }
            alt=""
          />
          <img
            src={logoutIcon}
            alt=""
            style={{ height: "35px" }}
            onClick={this.handleLogout}
          />
        </div>
        <div style={{ padding: 20 }} className="menu-grids">
          {/* <Row gutter={[16, 16]} style={{ height: "auto" }}>
            {this.features.map((feature, index) => {
              let canView = this.rolePermission2[feature.url]?.canView;
              if (
                feature.class === "expirySoonClass" &&
                this.rolePermission2?.vehiclelist?.canView === 0
              ) {
                canView = 0;
              } else if (feature.class === "expirySoonClass") {
                canView = 1;
              }

              if (feature.class === "helpClass") {
                canView = 1;
              }

              return (
                <Col
                  span={feature.span}
                  key={index}
                  className={
                    feature.url && canView === 1
                      ? feature.class
                      : `${feature.class} Disabledclass`
                  }
                >
                  <Card
                    title={
                      <span className={feature.spanClass || ""}>
                        <img src={feature.icon} alt="" />
                        <h3>
                          {feature.class === "historytrackingClass" ||
                          feature.class === "detailTrackingClass" ||
                          feature.class === "maintenanceClass"
                            ? this.splitString(feature.title)
                            : feature.title}
                        </h3>
                      </span>
                    }
                    style={{
                      ...feature.style,
                      width: "100%",
                      // height: "auto",
                    }}
                    headStyle={{ fontWeight: "bold" }}
                    bodyStyle={{
                      padding: 16,
                      flex: 1,
                      overflow: "hidden",
                    }}
                    onClick={() => {
                      if (feature.url && canView === 1) {
                        this.updateDashboard(feature.url, 0);
                      }
                    }}
                    hoverable={
                      !!feature.url &&
                      this.rolePermission2[feature.url]?.canView === 1
                    }
                  >
                    <div>
                      {feature.description}
                      {feature.extraInfo && <div>{feature.extraInfo}</div>}
                    </div>
                  </Card>
                </Col>
              );
            })}
          </Row> */}

          <Row gutter={[16, 16]} style={{ height: "92%" }}>
            {this.features.map((feature, index) => {
              let canView = this.rolePermission2[feature.url]?.canView;
              if (
                feature.class === "expirySoonClass" &&
                this.rolePermission2?.vehiclelist?.canView === 0
              ) {
                canView = 0;
              } else if (feature.class === "expirySoonClass") {
                canView = 1;
              }

              if (feature.class === "helpClass") {
                canView = 1;
              }

              return (
                <Col
                  span={feature.span}
                  key={index}
                  className={
                    feature.url && canView === 1
                      ? feature.class
                      : `${feature.class} Disabledclass`
                  }
                >
                  <Card
                    title={
                      <span
                        className={feature.spanClass ? feature.spanClass : ""}
                      >
                        <img src={feature.icon} />
                        <h3>
                          {feature.class === "historytrackingClass" ||
                          feature.class === "detailTrackingClass" ||
                          feature.class === "maintenanceClass"
                            ? this.splitString(feature.title)
                            : feature.title}
                        </h3>
                      </span>
                    }
                    style={{ ...feature.style }}
                    headStyle={{ fontWeight: "bold" }}
                    bodyStyle={{ minHeight: 100 }}
                    onClick={() => {
                      if (feature.url && canView === 1) {
                        this.updateDashboard(feature.url, 0);
                      }
                    }}
                    hoverable={
                      !!feature.url &&
                      this.rolePermission2[feature.url]?.canView === 1
                    }
                  >
                    <div
                      style={{
                        fontSize: "10px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "normal",
                        overflow: "hidden",
                      }}
                    >
                      {feature.description}
                      {feature.extraInfo}
                    </div>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </div>
      </div>
    );
  }
}

LounchingDashboard.contextType = StoreContext;
export default observer(withRouter(LounchingDashboard));
